import React from 'react';
import { PRODUCT_MOCKUP, PRODUCT_MOCKUP_ALT } from '../data/product';

/**
 * Shows the uploaded mockup when PRODUCT_MOCKUP is set; otherwise draws the
 * cover in code in the product look: deep navy cover, court colour strip,
 * a volleyball on a warm-floor band.
 */
export function ProductVisual({
  className = '',
  lazy = false
}: {
  className?: string;
  lazy?: boolean;
}) {
  if (PRODUCT_MOCKUP) {
    return <img src={PRODUCT_MOCKUP} alt={PRODUCT_MOCKUP_ALT} loading={lazy ? 'lazy' : undefined} className={`mx-auto h-auto w-full rounded-3xl shadow-book ring-4 ring-white/10 ${className}`} data-id="element-281" data-mp="o2dy31sidfxv" />;
  }
  return <div className={`relative mx-auto ${className}`} role="img" aria-label={PRODUCT_MOCKUP_ALT} data-id="element-282" data-mp="f7818sb7u87h">
      {/* the other volumes, fanned behind */}
      <div className="absolute inset-0 translate-x-[9%] translate-y-[2%] rotate-[6deg] rounded-[14px] bg-amber shadow-book" aria-hidden="true" data-id="element-283" data-mp="16zym66ng8ahf" />
      <div className="absolute inset-0 translate-x-[6%] translate-y-[1.5%] rotate-[4deg] rounded-[14px] bg-teal shadow-book" aria-hidden="true" data-id="element-284" data-mp="1bt1k0qz9e63f" />
      <div className="absolute inset-0 translate-x-[3%] translate-y-[1%] rotate-[2deg] rounded-[14px] bg-indigo shadow-book" aria-hidden="true" data-id="element-285" data-mp="1zdrqjx4f6eg5" />

      <div style={{
      containerType: 'inline-size'
    }} className="relative aspect-[4/3] overflow-hidden rounded-[14px] bg-ink shadow-book" data-id="element-286" data-mp="2e3gxya33veov">
        <span className="apparatus-strip absolute inset-x-0 top-0 h-[3.2%]" aria-hidden="true" data-id="element-287" data-mp="2n22l6ijivhvz" />
        <div className="relative px-[7%] pt-[8%]" data-id="element-288" data-mp="2j20j489vkmg6">
          <p className="font-display text-[3cqw] font-bold uppercase tracking-[0.2em] text-amber" data-id="element-289" data-mp="2j3lf82bu8dg5">
            A full year · 52 weekly sessions
          </p>
          <p className="mt-[2cqw] font-display text-[8.2cqw] font-extrabold leading-[0.95] tracking-tight text-white" data-id="element-290" data-mp="2s2ynwss50xzt">
            52 Weeks of
            <br data-id="element-291" data-mp="12otw6g0l0iji" />
            Volleyball
            <br data-id="element-292" data-mp="xophmvj8hxvx" />
            Practice Plans
          </p>
          <p className="mt-[2.4cqw] max-w-[58%] font-sans text-[3.1cqw] font-medium leading-snug text-white/70" data-id="element-293" data-mp="xq8xil0za6x6">
            Done-for-You Practice Plans &amp; Drills
          </p>
        </div>

        {/* warm floor band + volleyball */}
        <svg viewBox="0 0 400 300" className="absolute inset-0 h-full w-full" aria-hidden="true" data-id="element-294" data-mp="36qkd71ildq9q">
          <rect x="0" y="236" width="400" height="64" fill="#D8A86A" opacity="0.22" data-id="element-295" data-mp="3bq6r7d68vajl" />
          <line x1="24" y1="252" x2="376" y2="252" stroke="#E9A62E" strokeWidth="2.5" strokeDasharray="2 9" strokeLinecap="round" data-id="element-296" data-mp="3gpjd9vpakdl4" />
          {/* volleyball */}
          <g transform="translate(316 194)" data-id="element-297" data-mp="3llzzulguejw3">
            <circle cx="0" cy="0" r="34" fill="#F6F4EF" stroke="#122143" strokeWidth="2.6" data-id="element-298" data-mp="3qeks3ik3ooxi" />
            <path d="M-31 -13 C -8 -2, 9 15, 25 33" fill="none" stroke="#122143" strokeWidth="2.2" data-id="element-299" data-mp="3ugxvi0bdkar4" />
            <path d="M-3 -34 C 4 -9, 2 12, 11 33" fill="none" stroke="#122143" strokeWidth="2.2" data-id="element-300" data-mp="3an12n0ve88r" />
            <path d="M-34 7 C -8 8, 16 1, 34 -9" fill="none" stroke="#122143" strokeWidth="2.2" data-id="element-301" data-mp="88olpcdy2fmc" />
          </g>
          {/* level dots */}
          <g transform="translate(28 214)" data-id="element-302" data-mp="ieprtj6pgti7">
            <circle cx="0" cy="0" r="5" fill="#16B8A6" data-id="element-303" data-mp="debje016zhjn" />
            <circle cx="16" cy="0" r="5" fill="#E9A62E" data-id="element-304" data-mp="dcqp8bisi0mb" />
            <circle cx="32" cy="0" r="5" fill="#F5832B" data-id="element-305" data-mp="8e72wa0aamtf" />
          </g>
          <text x="28" y="282" fill="#AEB6CC" fontFamily="Poppins, sans-serif" fontWeight="700" fontSize="10.5" letterSpacing="1.6" data-id="element-306" data-mp="4ddfriuo1c1l">
            SERVE · PASS · SET · ATTACK · BLOCK · DIG
          </text>
        </svg>
      </div>
    </div>;
}